module.exports = __webpack_public_path__ + "25c85cd2b9958e6689d50a91a30480fb.jpg";